import LocationMarker from '@allesauto/design/graphics/location--filled.svg';
import React, { FC } from 'react';

export interface MarkerProps {
  lat: number;
  lng: number;
  markerId: string;
}

const Marker: FC<MarkerProps> = (props) => {
  const { markerId } = props;

  return (
    <LocationMarker className="-translate-x-1/2 -translate-y-full absolute h-40px w-40px">
      {markerId}
    </LocationMarker>
  );
};

export default Marker;
